// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"a8dbd3f5","378":"fec0a883","507":"f9c75897","604":"e6925a3c","985":"e5a7230b"}[chunkId] + ".css";
};